import type { CSSProperties, ReactNode } from "react";
import { Grid } from "../shared/components/Grid";
import Sidebar from "../shared/components/Sidebar";
import "./Layout.scss";

type LayoutProps = {
  activePath: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function Layout({
  activePath,
  children,
  className = "",
  style,
}: LayoutProps) {
  return (
    <Grid className={`app-layout ${className}`.trim()} style={style}>
      <Sidebar activePath={activePath} />
      {children}
    </Grid>
  );
}
